// src/utils/constants.js

import {
  Medal,
  Home,
  Clock,
  Users,
  HeartHandshake,
  BadgePercent,
  Wifi,
  ShowerHead,
} from 'lucide-react';
import { messages } from './messages';

// ============================================================================
// ====================== ОСНОВНАЯ ИНФОРМАЦИЯ КЛУБА ==========================
// ============================================================================

export const CLUB_INFO = {
  phoneDisplay: '+7 (921) 933-44-40',  // Для отображения на сайте
  phone: '+79219334440',                // Для ссылки tel: (с +) - ОСНОВНОЙ
  phoneRaw: '79219334440',              // Только цифры (запасной)
  address: 'деревня Князево, 1/1, Петергоф',
  hours: 'Пн-Вс: 7:00 - 3:00',
  coordinates: {
    lat: 59.853041,
    lng: 29.903277
  },
  maps: {
    yandex: 'https://yandex.ru/maps/-/CPuO42l-',
    google: 'https://maps.google.com/?q=59.853041,29.903277'
  },
  social: {
    vk: 'https://vk.com/tennisknyazevo',
    telegram: 'https://t.me/knyazevoclub',
    max: 'https://max.ru/u/f9LHodD0cOL3Hd77xBtZSTC1zSMaBAbO1YPXwzZRmraNKncilAObhrpg8aA',
  }
};

// ============================================================================
// ============================== ШАПКА (HEADER) ==============================
// ============================================================================

export const HEADER = {
  title: 'Современный теннисный клуб',
  carouselImages: [
    'tennis-court-1.jpg',
    'tennis-court-2.jpg',
    'tennis-court-3.jpg'
  ]
};

// ============================================================================
// ========================== ГЛАВНАЯ (FEATURES) ==============================
// ============================================================================

export const FEATURES = {
  title: 'Что мы предлагаем',
  items: [
    { icon: Medal, title: 'Профессиональные тренеры' },
    { icon: Home, title: '2 крытых отапливаемых корта' },
    { icon: Clock, title: 'Гибкий график работы' },
    { icon: Users, title: 'Тренировки для взрослых и детей любого возраста' },
    { icon: HeartHandshake, title: 'Дружелюбная атмосфера' },
    { icon: BadgePercent, title: 'Доступные цены и ежемесячные акции' },
    { icon: Wifi, title: 'Комфортная зона ожидания с бесплатным Wi-Fi' },
    { icon: ShowerHead, title: 'Просторные раздевалки и душевые' },
  ],
  cta: {
    title: 'Начните играть сегодня',
    buttonText: 'Позвонить'
  }
};

// ============================================================================
// ========================== О КЛУБЕ (ABOUT) =================================
// ============================================================================

export const ABOUT = {
  title: 'О нашем клубе',
  paragraphs: [
    'Современный теннисный клуб с уютной атмосферой, где каждый найдет подходящую компанию для игры. Мы создали пространство для любителей тенниса любого уровня подготовки.',
    'Наша цель — сделать теннис доступным и приятным. Приходите и убедитесь сами!'
  ],
  buttonText: 'Записаться на тренировку',
  image: 'tennis-court.jpg'
};

// ============================================================================
// ========================== ТРЕНЕРЫ (COACHES) ===============================
// ============================================================================

export const COACHES = {
  title: 'Наши тренеры',
  description: 'Каждый тренер обладает своей уникальной специализацией и индивидуальным подходом к обучению. Мы поможем вам достигнуть целей в теннисе, независимо от вашего уровня подготовки.',
  viewDetails: 'Подробнее →',
  contact: {
    title: 'Хотите записаться на тренировку?',
    text: 'Позвоните нам или напишите в Telegram для быстрой связи'
  },
  list: [
    {
      id: 1,
      name: 'Айден Павел Андреевич',
      shortDescription: 'Многократный победитель и призер турниров. Обучение техническим, физическим, тактическим аспектам игры взрослых и детей различного уровня.',
      detailedDescription: `Обучался теории и практике в ДЮСШ (Тверская обл.). Многократный победитель и призер клубных, городских, областных и региональных турниров Тверской, Ленинградской областей и Санкт-Петербурга в индивидуальных, парных и командных разрядах.\n\nИмеет большой тренировочный, теоретический и игровой опыт. Играл и тренировался в Сербии на кортах теннисного центра Новака Джоковича и академии Янко Типсаревича.\n\nОбладает обширным опытом спарринга с игроками разного уровня (и юниоры, и взрослые РТТ), обучения техническим, физическим, тактическим аспектам игры взрослых и детей различного уровня.`,
      experience: 'В большом теннисе с 10ти лет',
      education: 'Высшее инженерное образование (СПБГМТУ) + диплом тренера-преподавателя (НАДПО)',
      achievements: 'Тренировался в Сербии на кортах Новака Джоковича',
      specialties: ['Техническая подготовка', 'Тактическая подготовка', 'Физическая подготовка', 'Спарринг'],
      image: 'pavel.jpg'
    },
    {
      id: 2,
      name: 'Цыберенко Иван Анатольевич',
      shortDescription: 'Участник более 100 турниров в Санкт-Петербурге и Ленинградской области в одиночном и парном разряда.',
      detailedDescription: `Имеет обширный игровой опыт с теннисистами от любительского уровня до мастеров спорта. Регулярно практикуется и проводит спарринги с чемпионами города в возрастных категориях от 17 до 19 лет.\n\nВ настоящее время занимается у тренера сборной Санкт-Петербурга.\n\nС 2024 года занимается тренерской деятельностью.\n\nГотов привить любовь к теннису как взрослым, так и детям, помогая развивать технику, игровое мышление и уверенность на корте`,
      experience: 'В большом теннисе с 4х лет',
      achievements: 'Участник более 100 турниров в Санкт-Петербурге и Ленинградской области в одиночном и парном разрядах',
      specialties: ['Развивает технику и игровое мышление', 'Спарринг', 'Готов привить любовь к теннису'],
      image: 'ivan.jpg'
    },
    {
      id: 3,
      name: 'Тухтаматова Шахсия Радиковна',
      shortDescription: 'Теннисист международного уровня, выступала на турнирах WTA и ITF. Кандидат в мастера спорта.',
      detailedDescription: `В 8 лет была зачислена в школу Олимпийского резерва. Окончила Колледж Олимпийского резерва по профессии тренер по теннису.\n\nВходила в состав сборной Республики Узбекистан. На протяжении многих лет была первой ракеткой города Наманган и 10-ой ракеткой Республики.\n\nС 2017 года занимается тренерской деятельностью.\n\nТеннисист международного уровня\nВыступала на таких турнирах как WTA и ITF\nЯвляется кандидатом в мастера спорта\nМногократный победитель и призер турниров`,
      experience: 'В теннисе с 4х лет',
      education: 'Колледж Олимпийского резерва',
      achievements: 'Первая ракетка города Наманган, сборная Узбекистана',
      specialties: ['Профессиональная подготовка', 'Соревновательная практика', 'Международный опыт', 'Спарринг'],
      image: 'shahsiya.jpg'
    },
    {
      id: 4,
      name: 'Шубенков Дмитрий Леонидович',
      shortDescription: 'Постоянный участник и призёр различных теннисных турниров, организатор турниров.',
      detailedDescription: `Постоянный участник и призёр различных теннисных турниров, а также организатор турниров по одиночной и парной игре.\n\nПроводит занятия со взрослыми и детьми с нуля и различного уровня подготовки, индивидуально и в группах.\n\nЗанимается спаррингом с игроками один на один, а также в парном варианте игры. Обучает навыкам игры на счёт, в том числе в парном виде игры в теннис.\n\nОбладает богатым опытом участия в соревнованиях различного уровня, что позволяет эффективно готовить игроков к турнирным выступлениям.`,
      experience: 'Занимается теннисом с 2010 года',
      education: 'Специализированное теннисное образование',
      achievements: 'Организатор турниров, постоянный участник и призёр соревнований',
      specialties: ['Обучение с нуля', 'Парная игра', 'Подготовка к турнирам'],
      image: 'dmitry.jpg'
    },

    {
      id: 5, 
      name: 'Турчин Егор Дмитриевич',
      shortDescription: 'Международный опыт, профессиональный тренер.',
      detailedDescription: `Путь в теннисе начался в Racquet Club Benalmádena, спортивном комплексе в Бенальмадене (провинция Малага, Испания).

      На протяжении 15 лет, Егор активно участвовал в международных соревнованиях, что позволило ему не только развить свои игровые качества, но и приобрести ценный опыт конкуренции на высоком уровне. После этого он продолжил свою карьеру, тренировался и играл в Санкт-Петербурге, что дало ему возможность расширить свои горизонты и адаптироваться к различным стилям игры.

      Пройдя профессиональные теннисные курсы, стал тренером и начал передавать свои знания и опыт спортсменам.`,
      experience: 'В большом теннисе с 5ти лет',
      education: 'Профессиональные теннисные курсы, Racquet Club Benalmádena',
      achievements: 'Международные соревнования (Испания, Санкт-Петербург)',
      specialties: ['Международный опыт', 'Игровая практика', 'Обучение с нуля', 'Подготовка к турнирам'],
      image: 'egor.jpg'
},
  ]
};

// ============================================================================
// ========================== ЛЕТНИЙ ДЕТСКИЙ ЛАГЕРЬ ===========================
// ============================================================================

export const SUMMER_CAMP = {
  title: 'ТЕННИСНЫЙ ЛАГЕРЬ 2026',
  subtitle: 'Летние каникулы с теннисом',
  description: 'Приглашаем детей от 6 до 14 лет провести лето активно и с пользой. Ежедневные тренировки, игры, развлечения и новые друзья!',
  prices: {
    fullDay: '2 500 ₽/день',
    week: '12 000 ₽/неделя',
    month: '45 000 ₽'
  },
  includes: [
    '3 часа теннисных тренировок в день',
    '1 час общей физической подготовки',
    'Выезды на мероприятия',
    'Игры, квесты, викторины',
    'Велопрогулки',
    '2-х разовое питание'
  ],
  contact: {
    title: 'Записаться в лагерь',
    text: 'Остались вопросы? Свяжитесь с нами!'
  }
};

// ============================================================================
// ========================== КАТАЛОГ ТОВАРОВ ================================
// ============================================================================

export const CATALOG = {
  title: 'Каталог товаров',
  products: [
    // Крупные товары (сумки, ракетки, одежда, полотенца, мячи, виброгасители)
    { id: 17, name: 'Спортивная сумка', price: '1200 ₽', image: 'sportsumka.jpg' },
    { id: 21, name: 'Спортивный рюкзак', price: '1500 ₽', image: 'sportrukzak.jpg' },
    { id: 25, name: 'Ракетка для взрослых 361°', price: '3500 ₽', image: 'raketka.jpg' },
    { id: 26, name: 'Ракетка для взрослых Peak', price: '4000 ₽', image: 'raketka1.jpg' },
    { id: 22, name: 'Юбка для тенниса', price: '2000 ₽', image: 'ubka.jpg' },
    { id: 24, name: 'Полотенце спортивное Puma', price: '400 ₽', image: 'polotence.jpg' },
    { id: 14, name: 'Мячи для тенниса (4 шт.)', price: '1300 ₽', image: 'ball.jpg' },
    { id: 16, name: 'Виброгасители', price: '200 ₽', image: 'vibrogasitel.jpg' },
    { id: 19, name: 'Виброгасители длинные Wilson', price: '400 ₽', image: 'vibrogasitellong.jpg' },
    { id: 20, name: 'Виброгасители длинные', price: '400 ₽', image: 'vibrogasitellong1.jpg' },
    { id: 15, name: 'Обмотки для теннисных ракеток', price: '200 ₽', image: 'obmotka.jpg' },
    { id: 23, name: 'Чехол для ракетки Wilson', price: '400 ₽', image: 'chekol.jpg' },
    { id: 18, name: 'Напульсники', price: '200 ₽', image: 'napulsnik.jpg' },

    // Мелкие аксессуары (брелоки, браслеты, резинки, ручки и пр.)
    { id: 1, name: 'Брелок теннисный мяч', price: '250 ₽', image: 'brelok.jpg' },
    { id: 27, name: 'Брелок теннисная ракетка', price: '200 ₽', image: 'breloktre.jpg' },
    { id: 8, name: 'Брелок зелёный теннисный', price: '150 ₽', image: 'brelokzelen.jpg' },
    { id: 11, name: 'Брелок мягкий теннисный мячик', price: '400 ₽', image: 'brelokball.jpg' },
    { id: 12, name: 'Брелок пушистый', price: '400 ₽', image: 'brelokpush.jpg' },
    { id: 13, name: 'Брелок теннис', price: '200 ₽', image: 'breloktwo.jpg' },
    { id: 4, name: 'Браслет 3 теннисных мячика', price: '100 ₽', image: 'braslet.jpg' },
    { id: 5, name: 'Парный теннисный браслет', price: '150 ₽', image: 'brasletparn.jpg' },
    { id: 9, name: 'Браслет черный с теннисной ракеткой', price: '120 ₽', image: 'brasletblack.jpg' },
    { id: 2, name: 'Силиконовое кольцо на ручку ракетки', price: '100 ₽', image: 'silikon.jpg' },
    { id: 3, name: 'Резинка для волос', price: '100 ₽', image: 'rezinka.jpg' },
    { id: 7, name: 'Ручка - теннисная ракетка', price: '100 ₽', image: 'raket.jpg' },
    { id: 10, name: 'Расческа для волос', price: '500 ₽', image: 'hairbrush.jpg' },
    { id: 6, name: 'Стирательная резинка', price: '20 ₽', image: 'stiralka.jpg' }
]
};

// ============================================================================
// ======================== ПОДАРОЧНЫЕ СЕРТИФИКАТЫ ============================
// ============================================================================

export const CERTIFICATES = {
  title: 'Подарочные сертификаты',
  subtitle: 'Идеальный подарок для любителей тенниса',
  list: [
    { id: 1, name: 'Сертификат 2000 ₽', description: 'Подарочный сертификат на сумму 2000 рублей', image: 'nominal2000.jpg' },
    { id: 2, name: 'Сертификат 3000 ₽', description: 'Подарочный сертификат на сумму 3000 рублей', image: 'nominal3000.jpg' },
    { id: 3, name: 'Сертификат 4000 ₽', description: 'Подарочный сертификат на сумму 4000 рублей', image: 'nominal4000.jpg' },
    { id: 4, name: 'Сертификат 5000 ₽', description: 'Подарочный сертификат на сумму 5000 рублей', image: 'nominal5000.jpg' }
  ]
};

// ============================================================================
// ========================== ФОТОГАЛЕРЕЯ ====================================
// ============================================================================

export const GALLERY = {
  title: 'Фотогалерея',
  subtitle: 'Посмотрите, как проходят тренировки в нашем клубе',
  photos: ['1.jpg', '2.jpg', '3.jpg', '4.jpg', '5.jpg', '6.jpg', '7.jpg', '8.jpg']
};

// ============================================================================
// ========================== НОВОСТИ И АКЦИИ =================================
// ============================================================================

export const NEWS = {
  title: 'Новости и акции',
  subtitle: 'Следите за последними событиями и специальными предложениями клуба',
  loading: 'Загружаем новости и акции...',
  error: 'Не удалось загрузить новости',
  readMore: 'Читать полностью →',
  vkSection: {
    title: 'Все новости и акции в нашей группе ВКонтакте',
    description: 'Подписывайтесь, чтобы быть в курсе всех событий, турниров, акций и мероприятий',
    buttonText: 'Перейти к новостям ВКонтакте'
  }
};

// ============================================================================
// ========================== ЦЕНЫ ============================================
// ============================================================================

export const PRICES = {
  title: 'Прайс-лист',
  
  categories: {
    children: 'Детские группы',
    courtRental: 'Аренда корта',
    courtRentalCourt1: 'Аренда корта №1 (короткие забеги)',
    courtRentalCourt2: 'Аренда корта №2 (длинные забеги)',
    courtSubscription: 'Абонементы на аренду корта',
    courtSubscriptionCourt1: 'Абонементы на аренду корта №1',
    courtSubscriptionCourt2: 'Абонементы на аренду корта №2',
    individual: 'Индивидуальные занятия',
    split: 'Сплит-тренировки',
    group: 'Групповые занятия для взрослых',
    tennisCannon: 'Аренда теннисной пушки',
    additional: 'Дополнительные услуги'
  },
  
  tableHeaders: {
    single: 'Разовое занятие',
    subscription4: 'Абонемент 4 занятия',
    subscription8: 'Абонемент 8 занятий',
    subscription12: 'Абонемент 12 занятий',
    days: 'Дни недели',
    time: 'Время',
    price: 'Цена'
  },
  
  notes: {
    title: 'Важная информация:',
    items: [
      'Все цены указаны за занятия длительностью 1 час',
      'Срок любого абонемента – 1 месяц',
      'Абонементы на аренду корта не действуют по выходным дням',
      'Отмена записи за 12 часов до занятия'
    ]
  },
  
  children: {
    single: '1 400 ₽',
    subscription4: '5 200 ₽',
    subscription8: '9 600 ₽',
    subscription12: '13 200 ₽',
    perLesson4: '1 300 ₽',
    perLesson8: '1 200 ₽',
    perLesson12: '1 100 ₽'
  },
  
  // Аренда корта №1 (короткие забеги)
  courtRentalCourt1: {
    weekday: {
      morning: { time: '06:00-16:00', price: '1 900 ₽' },
      evening: { time: '16:00-23:00', price: '2 500 ₽' },
      night: { time: '23:00-00:00', price: '1 700 ₽' }
    },
    weekend: {
      full: { time: '06:00-23:00', price: '2 000 ₽' },
      night: { time: '23:00-00:00', price: '1 700 ₽' }
    }
  },
  
  // Аренда корта №2 (длинные забеги)
  courtRentalCourt2: {
    weekday: {
      morning: { time: '06:00-16:00', price: '2 200 ₽' },
      evening: { time: '16:00-23:00', price: '2 800 ₽' },
      night: { time: '23:00-00:00', price: '2 000 ₽' }
    },
    weekend: {
      full: { time: '06:00-23:00', price: '2 300 ₽' },
      night: { time: '23:00-00:00', price: '2 000 ₽' }
    }
  },
  
  // Абонементы на аренду корта №1
  courtSubscriptionCourt1: {
    morning: {
      subscription4: '7 200 ₽',
      subscription8: '13 600 ₽',
      perLesson4: '1 800 ₽',
      perLesson8: '1 700 ₽'
    },
    evening: {
      subscription4: '9 200 ₽',
      subscription8: '16 800 ₽',
      perLesson4: '2 300 ₽',
      perLesson8: '2 100 ₽'
    }
  },
  
  // Абонементы на аренду корта №2
  courtSubscriptionCourt2: {
    morning: {
      subscription4: '8 400 ₽',
      subscription8: '16 000 ₽',
      perLesson4: '2 100 ₽',
      perLesson8: '2 000 ₽'
    },
    evening: {
      subscription4: '10 400 ₽',
      subscription8: '19 200 ₽',
      perLesson4: '2 600 ₽',
      perLesson8: '2 400 ₽'
    }
  },
  
  // Аренда теннисной пушки (отдельно)
  tennisCannon: {
    single: '800 ₽',
    subscription4: '2 800 ₽',
    subscription8: '4 800 ₽',
    perLesson4: '700 ₽',
    perLesson8: '600 ₽'
  },
  
  individual: {
    morning: {
      single: '3 700 ₽',
      subscription4: '14 400 ₽',
      subscription8: '28 000 ₽',
      perLesson4: '3 600 ₽',
      perLesson8: '3 500 ₽'
    },
    evening: {
      single: '4 300 ₽',
      subscription4: '16 400 ₽',
      subscription8: '31 200 ₽',
      perLesson4: '4 100 ₽',
      perLesson8: '3 900 ₽'
    },
    pavel: {
      morning: {
        single: '4 100 ₽',
        subscription4: '16 000 ₽',
        subscription8: '31 200 ₽',
        perLesson4: '4 000 ₽',
        perLesson8: '3 900 ₽'
      },
      evening: {
        single: '4 700 ₽',
        subscription4: '18 000 ₽',
        subscription8: '34 400 ₽',
        perLesson4: '4 500 ₽',
        perLesson8: '4 300 ₽'
      }
    }
  },
  
  split: {
    single: '2 400 ₽',
    subscription4: '8 800 ₽',
    subscription8: '16 000 ₽',
    perLesson4: '2 200 ₽',
    perLesson8: '2 000 ₽',
    pavel: {
      single: '2 600 ₽',
      subscription4: '9 600 ₽',
      subscription8: '17 600 ₽',
      perLesson4: '2 400 ₽',
      perLesson8: '2 200 ₽'
    }
  },
  
  group: {
    single: '2 000 ₽',
    subscription4: '7 200 ₽',
    subscription8: '12 800 ₽',
    perLesson4: '1 800 ₽',
    perLesson8: '1 600 ₽'
  },
  
  additional: [
    { name: 'Аренда взрослой ракетки', price: '200 ₽' },
    { name: 'Аренда детской ракетки', price: '100 ₽' },
    { name: 'Аренда корзины с мячами', price: '200 ₽' },
    { name: 'Прокат полотенца', price: '100 ₽' }
  ]
};

// ============================================================================
// ========================== НАВИГАЦИЯ =======================================
// ============================================================================

export const NAVIGATION = {
  footer: [
    { name: 'Главная', path: '/' },
    { name: 'О клубе', path: '/about' },
    { name: 'Фотогалерея', path: '/gallery' },
    { name: 'Цены', path: '/prices' },
    { name: 'Каталог товаров', path: '/catalog' }
  ]
};

// ============================================================================
// ========================== ДОГОВОР ОФЕРТЫ ==================================
// ============================================================================

export const OFFER = {
  title: 'Публичная оферта (Договор)',
  approval: 'Утверждено индивидуальным предпринимателем Кудрявцевой Н.А. от 15 ноября 2023 г.',
  intro: 'Теннисный клуб Князево Club, в лице индивидуального предпринимателя Кудрявцевой Натальи Александровны, именуемый в дальнейшем «Исполнитель», предлагает любому физическому лицу, именуемому в дальнейшем «Заказчик», заключить настоящий договор о нижеследующем.',
  
  sections: [
    {
      title: '1. ОБЩИЕ ПОЛОЖЕНИЯ',
      items: [
        '1.1. В соответствии с пунктом 2 статьи 437 Гражданского Кодекса Российской Федерации (ГК РФ), в случае принятия изложенных ниже условий и оплаты услуг физическое лицо, производящее акцепт этой оферты, становится Заказчиком (в соответствии с пунктом 3 статьи 438 ГК РФ акцепт оферты равносилен заключению Договора на условиях, изложенных в оферте).',
        '1.2. Моментом полного и безоговорочного принятия Заказчиком предложения Исполнителя заключить Договор оферты считается факт оплаты предлагаемых услуг.',
        '1.3. Осуществляя акцепт Договора в порядке, определенном п. 1.2. Договора, Заказчик подтверждает, что он ознакомлен, согласен и полностью и безоговорочно принимает все условия Договора в том виде, в каком они изложены в тексте Договора, в том числе в приложениях к Договору, являющихся его неотъемлемой частью.',
        '1.4. Договор не требует скрепления печатями и/или подписания Заказчиком и Исполнителем и сохраняет при этом юридическую силу.'
      ]
    },
    {
      title: '2. ПРЕДМЕТ ДОГОВОРА',
      items: [
        '2.1. Предметом настоящего Договора является возмездное оказание Исполнителем образовательных услуг в соответствии с условиями настоящего Договора.',
        '2.2. Заказчик полностью принимает условия Договора и оплачивает услуги Исполнителя в соответствии с условиями настоящего Договора.',
        '2.3. В рамках настоящего договора Исполнителем могут оказываться дополнительные услуги, связанные с проведением соревнований, сборов и т.п. за отдельную плату, которая согласовывается дополнительным соглашением Сторон.'
      ]
    },
    {
      title: '3. ПРАВА И ОБЯЗАННОСТИ СТОРОН',
      исполнитель: {
        title: '3.1. Исполнитель обязуется:',
        items: [
          '3.1.1. Организовывать спортивно-тренировочный процесс по большому теннису для обучающегося лица в составе группы и согласно утвержденному расписанию.',
          '3.1.2. Обеспечить проведение занятий тренером в специально оборудованном помещении и предоставить необходимый исправный спортивный инвентарь.',
          '3.1.3. Обеспечить пожарную безопасность помещений теннисного клуба.',
          '3.1.4. В случае пропуска занятий по уважительной причине и предоставления справки от врача дать возможность получить услугу в иное время, соответствующее расписанию занятий.'
        ]
      },
      исполнительПрава: {
        title: '3.2. Исполнитель вправе:',
        items: [
          '3.2.1. Самостоятельно разрабатывать и утверждать спортивно-тренировочные программы, расписание занятий.',
          '3.2.2. Определять форму, средства и методы проведения занятий.',
          '3.2.3. В одностороннем порядке изменять расписание занятий, стоимость оказания услуг только с предварительным согласованием с Заказчиком.',
          '3.2.4. Вести фото- и видеосъемку во время тренировочного процесса, размещать материалы на своих интернет-площадках и в социальных сетях.',
          '3.2.5. Отказать Заказчику в возврате денежных средств или предоставлении занятий в другое время в случае пропуска занятий по неуважительной причине.',
          '3.2.6. Отказать в оказании услуг и отстранить от занятий при: систематическом или грубом нарушении Заказчиком дисциплины и установленных правил во время посещения теннисного клуба; своевременном невнесении оплаты оказываемых услуг.'
        ]
      },
      заказчик: {
        title: '3.3. Заказчик обязуется:',
        items: [
          '3.3.1. Оплачивать услуги Исполнителя в соответствии с условиями настоящего договора.',
          '3.3.2. Соблюдать установленные правила поведения на корте.',
          '3.3.3. Возместить ущерб, причиненный Заказчиком имуществу теннисного клуба, в соответствии с законодательством Российской Федерации.'
        ]
      },
      заказчикПрава: {
        title: '3.4. Заказчик вправе:',
        items: [
          '3.4.1. Знакомиться с ходом и содержанием тренировочного процесса, не вмешиваясь в его деятельность.',
          '3.4.2. Отказаться от исполнения условий Договора в любое время, с письменным уведомлением Исполнителя о расторжении настоящего договора.',
          '3.4.3. Отказаться (в письменном виде) от проведения сотрудниками теннисного клуба фото- и видеосъемки на занятиях или праздничных мероприятиях с целью последующего использования в социальных сетях.'
        ]
      }
    },
    {
      title: '4. УСЛОВИЯ ОПЛАТЫ',
      items: [
        '4.1. В случае приобретения абонемента, Заказчик посещает определенное в выбранном абонементе количество занятий в соответствии с утвержденным Сторонами графиком.',
        '4.2. Оплата услуг производится 100% предоплатой, в соответствии с утвержденным Исполнителем Прейскурантом, путем внесения наличных денежных средств или путем перечисления безналичных средств на расчетный счет Исполнителя.',
        '4.3. В случае невозможности оказания услуг по вине Исполнителя в период действия абонемента (отмена занятий по решению Исполнителя, болезнь тренера, иная уважительная причина), либо по техническим причинам (проведение аварийных работ службами коммунального хозяйства) срок действия абонемента продлевается соразмерно периоду отсрочки оказания услуг, при этом дополнительная плата с Заказчика не взимается.'
      ]
    },
    {
      title: '5. ОТВЕТСТВЕННОСТЬ СТОРОН',
      items: [
        '5.1. В случае неисполнения сторонами обязательств по настоящему договору, они несут ответственность, предусмотренную гражданским законодательством и законодательством по защите прав потребителей РФ.',
        '5.2. Споры и разногласия, возникшие при исполнении настоящего договора, будут, по возможности, разрешаться путем переговоров между Заказчиком и Исполнителем. В случае невозможности разрешения споров путем переговоров урегулирование претензий осуществляется в порядке, установленном законодательством РФ.',
        '5.3. Заказчик уведомлен, что занятие теннисным спортом может повлечь риски получения травм, и в случае наступления таковых не будет иметь в этой связи претензий к Исполнителю.',
        '5.4. Исполнитель не несет ответственности за вред, причиненный не по вине Исполнителя. В частности, Исполнитель не несет ответственность за действия других посетителей, за собственные неосторожные действия самого Заказчика, за применение ими принесенного инвентаря и т.п.',
        '5.5. Под виной Исполнителя понимаются случаи действий и бездействия самого Исполнителя и его работников, осуществляющих учебно-тренировочный процесс, необустроенности помещений, неисправности оборудования и т.п.'
      ]
    },
    {
      title: '6. ЗАКЛЮЧИТЕЛЬНЫЕ ПОЛОЖЕНИЯ',
      items: [
        '6.1. К настоящему договору применяются положения Закона РФ от 07.02.1992 N 2300-1 «О защите прав потребителей».',
        '6.2. При предоставлении и обработке персональных данных Стороны действуют в соответствии с Федеральным законом от 27.07.2006 N 152-ФЗ «О персональных данных». Исполнитель обязуется ограничить доступ к персональным данным Заказчика и осуществлять их сбор, хранение и использование исключительно в целях исполнения настоящего Договора.',
        '6.3. За утерянные или оставленные без присмотра вещи теннисный клуб ответственность не несет. Все найденные на территории клуба вещи хранятся не более трех месяцев, далее утилизируются.',
        '6.4. Публичная оферта вступает в силу с момента опубликования в группе Вконтакте https://vk.com/tennisknyazevo и действует до момента отзыва теннисным клубом.'
      ]
    }
  ],
  
  contactInfo: {
    title: 'Контактная информация',
    phone: 'По всем вопросам обращайтесь по телефону:',
    vk: 'Группа ВКонтакте:'
  }
};

// ============================================================================
// ========================== РАСПИСАНИЕ ======================================
// ============================================================================

export const SCHEDULE = {
  title: 'Расписание и запись',
  groups: {
    children: 'Детские группы',
    adult: 'Взрослые группы'
  },
  courtBooking: {
    title: 'Аренда корта',
    court1: 'Корт №1',
    court2: 'Корт №2',
    nightTime: '00:00 - 06:30',
    dayTime: '07:00 - 23:30'
  }
};

// ============================================================================
// ========================== ФОРМЫ ==========================================
// ============================================================================

export const FORM_MESSAGES = messages.validation;

export const REQUISITES = {
  ip: {
    fullName: 'ИП Кудрявцева Наталья Александровна',
    inn: '782300092084',
    ogrnip: '323784700371558',
    phone: '+7 (921) 933-44-40',
    email: 'natkud75@gmail.com'
  },
  bank: {
    account: '40802810800005557748',
    bankName: 'АО «Т-Банк»',
    bik: '044525974',
    correspondentAccount: '30101810145250000974'
  }
};